import { Person } from '../person/Person';
import { Organisation } from '../organisation/OrganisationModelV2';
import { PaymentProviderConfig } from './PaymentProviderConfig';
import { ACL } from './ACL';

export class Profile {
  device_id?: string;
  first_run_completed?: boolean;
  force_update?: boolean;
  person: Person;
  organisations: Organisation[];
  payment_provider_config?: PaymentProviderConfig;
  acl: ACL;

  constructor(data: any) {
    this.device_id = data.device_id;
    this.first_run_completed = data.first_run_completed;
    this.force_update = data.force_update;
    this.person = Person.build(data.person) || new Person(data.person);
    this.organisations = data.organisations?.map((org: any) => 
      Organisation.build(org) || new Organisation(org)
    ) || [];
    this.payment_provider_config = PaymentProviderConfig.build(data.payment_provider_config);
    this.acl = ACL.build(data.acl);
  }

  canNiaga(): boolean {
    return this.acl?.canNiaga() ?? false;
  }

  canReceivePayment(): boolean {
    return this.acl?.canReceivePayment() ?? false;
  }

  canWriteBid(orgId: number): boolean {
    return this.acl?.canWriteBid(orgId) ?? false;
  }

  canReadBid(orgId: number): boolean {
    return this.acl?.canReadBid(orgId) ?? false;
  }

  canWriteEmployee(orgId: number): boolean {
    return this.acl?.canWriteEmployee(orgId) ?? false;
  }

  hasPaymentConfig(): boolean {
    return this.payment_provider_config?.isActive() ?? false;
  }

  static build(data: any): Profile {
    return new Profile(data);
  }
}
